class HeroAnimated extends HTMLElement {
  connectedCallback() {
    this.slides = this.querySelectorAll('.hero-animated__slide');
    if (this.slides.length <= 1) return;

    this.current = 0;
    this.interval = parseInt(this.dataset.interval, 10);

    this.timer = setInterval(() => this.advance(), this.interval);

    this.addEventListener('mouseenter', () => clearInterval(this.timer));
    this.addEventListener('mouseleave', () => {
      this.timer = setInterval(() => this.advance(), this.interval);
    });
  }

  advance() {
    this.slides[this.current].classList.remove('hero-animated__slide--active');
    this.current = (this.current + 1) % this.slides.length;
    this.slides[this.current].classList.add('hero-animated__slide--active');
  }
}

if (!customElements.get('hero-animated')) {
  customElements.define('hero-animated', HeroAnimated);
}
